import { Button, Tag, Image } from "antd";
import UtilFunctions from "../../utils/Functions/utilFunctions";

const OtherCardColumns = (goToUpdatePage, deleteOtherCard) => [
  {
    title: "ID",
    dataIndex: "id",
    key: "id",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "Renk",
    dataIndex: "color",
    key: "color",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}>
          <div
            style={{
              backgroundColor: UtilFunctions.convertDecimalToColor(value),
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              border: "1px solid #ddd",
            }}
          />
        </div>
      </span>
    ),
  },
  {
    title: "Şirket Adı",
    dataIndex: "companyName",
    key: "companyName",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "Sık Kullanılan",
    dataIndex: "isCommonlyUsed",
    key: "isCommonlyUsed",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>
        {value ? <Tag color="green">Evet</Tag> : <Tag color="red">Hayır</Tag>}
      </span>
    ),
  },

  {
    title: "Durum",
    dataIndex: "status",
    key: "status",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>
        {value === 1 ? (
          <Tag color="green">Aktif</Tag>
        ) : value === 0 ? (
          <Tag color="red">Pasif</Tag>
        ) : value === -1 ? (
          <Tag color="gray">Silinmiş</Tag>
        ) : (
          <Tag color="blue">{value}</Tag>
        )}
      </span>
    ),
  },
  {
    title: "Fotoğraf",
    dataIndex: "logoUrl",
    key: "logoUrl",
    sorter: true,
    render: (value) => (
      <span
        style={{
          textAlign: "center",
          display: "block",
          backgroundColor: "black",
        }}>
        {value ? (
          <Image
            src={value}
            alt="Logo"
            style={{ width: 50, height: 50, objectFit: "contain" }}
          />
        ) : (
          value
        )}
      </span>
    ),
  },
  {
    title: "İşlemler",
    dataIndex: "operations",
    key: "operations",
    fixed: "right",
    render: (_, record) => (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Button type="link" onClick={() => goToUpdatePage({ record })}>
          Güncelle
        </Button>
        <Button
          disabled={record.status === -1}
          type="link"
          danger
          onClick={() => deleteOtherCard({ record })}>
          Sil
        </Button>
      </div>
    ),
  },
];

export { OtherCardColumns };
